import { create } from 'zustand';

export type ChooseIPEntryType = 'microdrama' | 'shortvideo' | 'emoji' | 'viral_remake';
export type ChooseIPPopupLocation = 'home_side_create_project' | 'home_create_project' | 'ai_short_video' | 'viral_remake' | 'emoji' | 'ai_daily_video';
export type ChooseIPTeamProjectLocation = 'team_add' | 'no_project';

export interface ChooseIPTeamProjectContext {
  folderId?: string | number;
  folderName?: string;
  location: ChooseIPTeamProjectLocation;
}

interface ChooseIPStore {
  isModalOpen: boolean;
  entryType?: ChooseIPEntryType;
  location?: ChooseIPPopupLocation;
  prompt: string;
  teamProjectContext?: ChooseIPTeamProjectContext;
}

const useChooseIPStore = create<ChooseIPStore>(() => ({
  isModalOpen: false,
  entryType: undefined,
  location: undefined,
  prompt: '',
  teamProjectContext: undefined,
}));

export default useChooseIPStore;

/**
 * 设置选择 IP 弹窗状态，关闭时清理场景及提示词。
 */
export function setChooseIPModalOpen(
  isModalOpen: boolean,
  entryType?: ChooseIPEntryType,
  prompt = '',
  location?: ChooseIPPopupLocation,
  teamProjectContext?: ChooseIPTeamProjectContext,
) {
  useChooseIPStore.setState(() => ({
    isModalOpen,
    entryType: isModalOpen ? entryType : undefined,
    location: isModalOpen ? location : undefined,
    prompt: isModalOpen ? prompt : '',
    teamProjectContext: isModalOpen ? teamProjectContext : undefined,
  }));
}

/**
 * 打开选择 IP 弹窗，并暂存首页场景及提示词。
 */
export function openChooseIPModal(
  entryType?: ChooseIPEntryType,
  prompt = '',
  location?: ChooseIPPopupLocation,
  teamProjectContext?: ChooseIPTeamProjectContext,
) {
  setChooseIPModalOpen(true, entryType, prompt, location, teamProjectContext);
}

/**
 * 关闭选择 IP 弹窗，避免场景及提示词残留到下次创建。
 */
export function closeChooseIPModal() {
  useChooseIPStore.setState(() => ({
    isModalOpen: false,
    entryType: undefined,
    location: undefined,
    prompt: '',
    teamProjectContext: undefined,
  }));
}
